import { calculateChunkSize } from './calculateChunkSize.js';

const calculateChunkCount = (fileSize, _chunkSize) => {
  const chunkSize = _chunkSize ?? calculateChunkSize(fileSize);
  if (fileSize <= chunkSize) {
    return 1;
  }
  return Math.ceil(fileSize / chunkSize);
};

export { calculateChunkCount };
//# sourceMappingURL=calculateChunkCount.js.map
